export enum StartupType {
  Essentials = 'Essentials',
  Basic = 'Basic',
  Plus = 'Plus',
}
